module.exports = __webpack_public_path__ + "static/image 11-07e62bf528cb3268c00f5026c1292ce2.png";